<template>
  <v-card
    density="comfortable"
    class="fill-height"
  >
    <v-card-title
      class="bg-primary"
    >
      {{ dayOverseerTitle }}
    </v-card-title>
    <v-card-text class="mt-3">
      <user-avatar :user="dayOverseer.user" />
      <div class="text-headline-small text-primary-darken-1">
        {{ dayOverseer.user.name }}
      </div>
      <div
        v-if="locationNames"
        class="text-body-large text-primary"
      >
        {{ t('location.title', 2) }}:<br>
        {{ locationNames }}
      </div>
      <div
        v-if="dayOverseer.notes"
        class="text-body-large text-font"
      >
        {{ dayOverseer.notes }}
      </div>
      <phone-number
        :number="dayOverseer.user.mobile_phone"
        class="mb-2"
      />
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import UserAvatar from '../images/UserAvatar.vue';

const props = defineProps<{
  dayOverseer: App.Models.DayOverseer;
  titleType?: string;
  title?: string;
}>();
const { t } = useI18n();

const locationNames = computed(() => {
  return props.dayOverseer.locations?.map((location: App.Models.Location) => location.name).join(', ');
});

const dayOverseerTitle = computed(() => {
  if (props.title) {
    return props.title;
  }
  if (props.titleType === 'dow') {
    return t(`dow.${props.dayOverseer.day_of_week}`);
  }
  if (props.titleType === 'today') {
    return t(`dow.today`);
  }
  return t('dayoverseer.contact', { type_of_overseer: props.dayOverseer.order_name });
});
</script>
